import { render, staticRenderFns } from "./MyNewsletter.vue?vue&type=template&id=81e2a508&scoped=true&"
import script from "./MyNewsletter.vue?vue&type=script&lang=js&"
export * from "./MyNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./MyNewsletter.vue?vue&type=style&index=0&id=81e2a508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e2a508",
  null
  
)

export default component.exports